import { render } from "./Components.vue?vue&type=template&id=16aeffd3"
import script from "./Components.vue?vue&type=script&lang=js"
export * from "./Components.vue?vue&type=script&lang=js"
script.render = render

export default script